export const ANALYTICS_EVENT_LIVE_CASINO = 'live-casino';
export const ANALYTICS_EVENT_CASINO = 'casino';
export const ANALYTICS_EVENT_SITE = 'site';
export const ANALYTICS_EVENT_SHOP = 'shop';
